<div style="display: flex; align-items: flex-start;" data-cy="report-viewer-container">
  <div style="flex-basis: 400px; padding: 10px 10px 10px 10px" data-cy="report-viewer-sidebar">

    <div style="background-color:var(--tdo-purple-light); padding: 10px 10px 10px 10px; margin-bottom: 20px" data-cy="report-viewer-header">
      <h5 data-cy="report-viewer-title">Reports</h5>
    </div>

    <div style="padding-left: 20px" data-cy="report-viewer-reports-list">
      <mat-radio-group aria-label="Select an option" style="display: flex; flex-direction: column" (change)="reportSelected($event)" data-cy="report-viewer-radio-group">
        <mat-radio-button *ngFor="let report of reports" [value]="report" [attr.data-cy]="'report-viewer-report-option-' + transformReportName(report.ReportName)">{{ report.ReportName }}</mat-radio-button>
      </mat-radio-group>
    </div>

    <div *ngIf="reportParametersString.length || reportParametersNumber.length || reportParametersBoolean.length || reportParametersDateTime.length" data-cy="report-viewer-parameters-section">
      <div style="background-color:var(--tdo-purple-light); padding: 10px 10px 10px 10px; margin-bottom: 20px; margin-top: 20px" data-cy="report-viewer-parameters-header">
        <h5 data-cy="report-viewer-parameters-title">Report Parameters</h5>
      </div>
    </div>

    <div style="padding-left: 20px" data-cy="report-viewer-parameters-container">
      <div *ngFor="let param of reportParametersString" data-cy="report-viewer-parameter-string-container">
        <mat-form-field data-cy="report-viewer-parameter-string-field">
          <mat-label data-cy="report-viewer-parameter-string-label">{{ param.ParameterLabel }}</mat-label>
          <input matInput [(ngModel)]="param.ParameterValueString" [attr.data-cy]="transformParameterLabel(param.ParameterLabel)">
        </mat-form-field>
      </div>

      <div *ngFor="let param of reportParametersNumber" data-cy="report-viewer-parameter-number-container">
        <mat-form-field data-cy="report-viewer-parameter-number-field">
          <mat-label data-cy="report-viewer-parameter-number-label">{{ param.ParameterLabel }}</mat-label>
          <input matInput [(ngModel)]="param.ParameterValueNumber" [attr.data-cy]="transformParameterLabel(param.ParameterLabel)">
        </mat-form-field>
      </div>

      <div *ngFor="let param of reportParametersBoolean" data-cy="report-viewer-parameter-boolean-container">
        <mat-slide-toggle [(ngModel)]="param.ParameterValueBoolean" [attr.data-cy]="transformParameterLabel(param.ParameterLabel)">{{ param.ParameterLabel }}</mat-slide-toggle>
      </div>

      <div *ngFor="let param of reportParametersDateTime; let i = index;" data-cy="report-viewer-parameter-date-container">
        <mat-form-field data-cy="report-viewer-parameter-date-field">
          <mat-label data-cy="report-viewer-parameter-date-label">{{param.ParameterLabel}}</mat-label>
          <input matInput [matDatepicker]="paramDate_i"
                 [(ngModel)]="param.ParameterValueDate" [attr.data-cy]="transformParameterLabel(param.ParameterLabel)">
          <mat-datepicker-toggle matSuffix [for]="paramDate_i" [attr.data-cy]="'report-viewer-parameter-date-toggle-' + i"></mat-datepicker-toggle>
          <mat-datepicker #paramDate_i></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="activeReport" style="padding-top:20px" data-cy="report-viewer-actions">
      <button mat-button color="primary" (click)="runReport()" data-cy="report-viewer-run-button">Run Report</button>
      <br>
      <button mat-button color="primary" (click)="runReportToPDF()" data-cy="report-viewer-pdf-button">Run Report to PDF</button>
    </div>

  </div>
  <div *ngIf="reportUrl" style="padding: 10px 10px 10px 0px; " data-cy="report-viewer-display">
    <div style="padding: 10px 10px 10px 10px; background-color: var(--tdo-purple-light); font-weight: bold; font-size: 20px" data-cy="report-viewer-display-header"><h5 data-cy="report-viewer-display-title">{{ this.activeReport.ReportName }}</h5></div>
    <dx-report-viewer [reportUrl]="reportUrl" height="800px" data-cy="report-viewer-dx-viewer">
      <dxrv-request-options [invokeAction]="invokeAction" [host]="hostUrl" data-cy="report-viewer-dx-options"></dxrv-request-options>
    </dx-report-viewer>
  </div>

  <br>
  <button mat-button color="primary" (click)="showDialog()" data-cy="report-viewer-dialog-button">Open in dialog</button>

</div>

